<div class="row">
  <div class="col-11">
    @for (el of toolBarElements; track el) {
      @if ((el.icon=='edit_calendar' && userCanCreate) || el.icon=='calendar_month') {
        <button
          [ngClass]="el.class"
          (click)="el.onClickAction()"
          [matTooltip]="el.name">
          <mat-icon>{{el.icon}}</mat-icon>
        </button>
      }
    }
    <button [matTooltip]="userOnCalendar ? 'Remove from Outlook Calendar' : 'Add to Outlook Calendar'" class="outlook-event-btn" (click)="onClickAction.emit(CompanyEventToolbarAction.Outlook)">
      <mat-icon>{{userOnCalendar ? 'delete' : 'mail_outline'}}</mat-icon>
    </button>
  </div>
  <div class="col-1">
    @if (userCanEdit) {
      <button mat-mini-fab class="edit-btn" [matTooltip]="isEditMode ? 'Save changes' : 'Edit company event'" (click)="editToggle()">
        @if (!isEditMode) {
          <mat-icon>edit</mat-icon>
        }
        @if (isEditMode) {
          <mat-icon>save</mat-icon>
        }
      </button>
    }
    @if (userCanEdit && isEditMode) {
      <button mat-mini-fab class="delete-btn" matTooltip="Delete Company Event" (click)="onClickAction.emit(CompanyEventToolbarAction.Delete)"><mat-icon>delete</mat-icon></button>
    }
  </div>
</div>
